var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14.0001C28 6.26851 21.7324 0 14 0C6.26764 0 0 6.26851 0 14.0001C0 21.7324 6.26755 28 14 28C21.7324 28 28 21.7325 28 14.0001ZM20.7927 9.95399C21.483 9.87344 22.1411 9.69582 22.7527 9.43163C22.2951 10.0966 21.7167 10.6794 21.0518 11.145L21.0614 11.5737C21.0614 15.9487 17.6295 20.9957 11.3541 20.9957C9.42652 20.9957 7.63445 20.4471 6.1233 19.5074C6.39108 19.538 6.66232 19.5537 6.93797 19.5537C8.53656 19.5537 10.0075 19.0252 11.1756 18.1363C9.68194 18.1099 8.42192 17.1527 7.98796 15.8367C8.19621 15.8761 8.40967 15.8962 8.62935 15.8962C8.94081 15.8962 9.24185 15.855 9.52799 15.7798C7.96693 15.4753 6.79101 14.1374 6.79101 12.5326V12.4907C7.25204 12.7399 7.77716 12.8879 8.33709 12.9054C7.42181 12.3129 6.81984 11.2979 6.81984 10.15C6.81984 9.54269 6.98785 8.97491 7.28185 8.48572C8.96357 10.4886 11.4783 11.8073 14.3134 11.9455C14.2548 11.7031 14.225 11.4502 14.225 11.1903C14.225 9.3616 15.7527 7.88026 17.6358 7.88026C18.6174 7.88026 19.5038 8.28186 20.126 8.92499C20.9039 8.77717 21.6337 8.50154 22.2933 8.12087C22.0387 8.89518 21.498 9.54361 20.7927 9.95399Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8b669aaf6dd6ac7ad4a33da8d7d83f1c.svg";
export { ForwardRef as ReactComponent };